import React, {forwardRef, useEffect, useRef, useState} from "react";
import './Modal.css'

const modalWidths = {
  'sm': 400,
  'lg': 600,
  'xl': 800,
  'xxl': 960,
}
type Props = {
  isVisible: boolean
  onClose?: () => any
  btnLabel?: string
  btnIcon?: string
  modalTitle?: string
  modalWidth?: 'sm' | 'lg' | 'xl' | 'xxl'
  content: any
  headerBtn?: any
  footerContent?: any
  modalOpenBtn?: any
  recalcHeightHash?: string | number
  contentClassName?: string
  autoHeight?: boolean
}
export const Modal = forwardRef<HTMLDivElement, Props>(
  ({ isVisible, onClose, btnLabel, btnIcon, modalTitle, modalWidth, content, headerBtn, footerContent, modalOpenBtn, recalcHeightHash, contentClassName, autoHeight }, ref) => {
    const [contentWidthPx, setContentWidthPx] = useState<number>(modalWidths[modalWidth] || 800)
    const [contentHeightPx, setContentHeightPx] = useState<number>(400)
    const [footerHeightPx, setFooterHeightPx] = useState<number>(60)
    const modalContentDivRef = useRef(null)
    const modalFooterDivRef = useRef(null)
    const onBackdropClick = (e) => {
      if (e?.target?.className === 'modal-backdrop') {
        typeof onClose === 'function' ? onClose() : null
      }
    }
    const modalHeaderHeight = 60
    const modalContentMarginBottom = 16
    const styles = autoHeight
      ? {
          left: `calc(50% - ${contentWidthPx / 2}px)`,
          width: `${contentWidthPx}px`,
          top: '50%',
          transform: 'translateY(-50%)',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column' as const,
        }
      : {
          top: `calc(50% - ${contentHeightPx / 2}px)`,
          left: `calc(50% - ${contentWidthPx / 2}px)`,
          width: `${contentWidthPx}px`,
          height: `${contentHeightPx}px`,
        }

    useEffect(() => {
      if (isVisible && modalContentDivRef?.current && modalFooterDivRef?.current) {
        setContentHeightPx(modalContentDivRef.current.clientHeight + modalHeaderHeight + modalContentMarginBottom + modalFooterDivRef.current.clientHeight)
        setFooterHeightPx(modalFooterDivRef.current.clientHeight)
        // todo debug createCustomer case..
        setTimeout(() => {
          setContentHeightPx(modalContentDivRef.current.clientHeight + modalHeaderHeight + modalContentMarginBottom + modalFooterDivRef.current.clientHeight)
        }, 10)
      }
    }, [isVisible, modalContentDivRef?.current, modalFooterDivRef?.current, recalcHeightHash])

    useEffect(() => {
      if (isVisible && modalWidth) {
        setContentWidthPx(modalWidths[modalWidth])
      }
    }, [isVisible, modalWidth])

    return (
      <>
        {modalOpenBtn}
        {isVisible && (
          <div className="modal-backdrop" ref={ref} onClick={onBackdropClick}>
            <div className="modal-container px-6" style={styles}>
              <div className="flex flex-row items-center justify-between modal-header py-6">
                <div className="modal-title">{modalTitle || ''}</div>
                <div className="modal-close">{headerBtn}</div>
              </div>
              <div ref={modalContentDivRef} className={`modal-content rounded-md shadow-sm p-4${contentClassName ? ` ${contentClassName}` : ''}`}>
                {content}
              </div>
              <div ref={modalFooterDivRef} className="modal-footer py-6 pb-2">
                {footerContent && (footerContent)}
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
)
